<template>
  <div>
    <b-table
      :items="items"
      :fields="campos"
      :empty-text="$t('GERAL.NENHUM_REGISTRO')"
      head-variant="light"
      stacked="md"
      show-empty
      striped
      hover
      @sort-changed="aoMudarOrdenacao"
    >
      <template #cell(acoes)="item">
        <b-dropdown variant="outline-default">
          <b-dropdown-item
            @click="verHistorico(item.item)"
            v-if="podeVisualizar"
          >
            Ver histórico
          </b-dropdown-item>

          <b-dropdown-item
            @click="abrirModalAtualizarHistoricosEscolares(item.item)"
            v-if="podeVisualizar"
          >
            {{ $t('ACADEMICO_MATRICULAS.ATUALIZAR_HISTORICO_ESCOLAR') }}
          </b-dropdown-item>
          
          <b-dropdown-item
            @click="abrirModalImprimirCertificado(item.item)"
            v-if="podeVisualizar"
          >
            {{ $t('ACADEMICO_MATRICULAS.IMPRIMIR_CERTIFICADO') }}
          </b-dropdown-item>

          <b-dropdown-item
            @click="abrirModalImprimirHistorico(item.item)"
            v-if="podeVisualizar"
          >
            {{ $t('ACADEMICO_MATRICULAS.IMPRIMIR_HISTORICO_ESCOLAR') }}

          </b-dropdown-item>
        </b-dropdown>
      </template>
    </b-table>
    <modal-imprimir-historico
      :exibir="modais.exibirImprimirHistorico"
      :item="modais.historicoDadosAluno"
      @fechar="fecharModalImprimirHistorico"
    />
    <modal-imprimir-certificado
      :exibir="modais.exibirImprimirCertificado"
      :item="modais.historicoDadosAluno"
      @fechar="fecharModalImprimirCertificado"
    />
    <modal-atualizar-historico
      :exibir="modais.atualizarHistoricos"
      :item="modais.historicoDadosAluno"
      @fechar="fecharModalAtualizarHistorico"
    />
  </div>
</template>
<script>
import helpers from '@/common/utils/helpers';
import Permissoes from '@/components/mixins/permissoes';
//components
import ModalImprimirHistorico from '@/views/academico/matriculas/components/ModalImprimirHistorico.vue';
import ModalAtualizarHistorico from '@/views/academico/matriculas/components/ModalAtualizarHistorico.vue';
import ModalImprimirCertificado from '@/views/academico/matriculas/components/ModalImprimirCertificado.vue';
export default {
  mixins: [Permissoes],
  components: {
    ModalImprimirHistorico,
    ModalImprimirCertificado,
    ModalAtualizarHistorico
  },
  props: {
    items: { type: Array, default: Array },
  },
  data() {
    return {
      campos: [
        {
          key: 'codigoMatricula',
          label: this.$t('ACADEMICO_MATRICULAS.CODIGO_MATRICULA'),
          sortable: true,
        },
        {
          key: 'nome',
          label: this.$t('ACADEMICO_MATRICULAS.ALUNO'),
          sortable: true,
        },
        {
          key: 'idiomaDescricao',
          label: this.$t('ACADEMICO_MATRICULAS.IDIOMA'),
          sortable: true,
        },
        {
          key: 'status',
          label: this.$t('GERAL.STATUS'),
          sortable: true,
        },
        {
          key: 'observacao',
          label: this.$t('GERAL.OBSERVACAO'),
          formatter: (value) => {
            return value ? `${value?.substring(0, 25)}...` : '-';
          },
        },
        {
          key: 'acoes',
          label: this.$t('GERAL.ACOES'),
        },
      ],
      modais: {
        exibirImprimirHistorico: false,
        exibirImprimirCertificado: false,
        atualizarHistoricos: false,
        historicoDadosAluno: {},
      },
    };
  },
  methods: {
    verHistorico(item) {
      this.$emit('historico', 'historico', item);
    },

    abrirModalImprimirHistorico(item) {
      this.modais.exibirImprimirHistorico = true;
      this.modais.historicoDadosAluno = item;
    },

    fecharModalImprimirHistorico() {
      this.modais.exibirImprimirHistorico = false;
      this.modais.historicoDadosAluno = {};
    },

    abrirModalImprimirCertificado(item) {
      this.modais.exibirImprimirCertificado = true;
      this.modais.historicoDadosAluno = item;
    },

    fecharModalImprimirCertificado() {
      this.modais.exibirImprimirCertificado = false;
      this.modais.historicoDadosAluno = {};
    },

    aoMudarOrdenacao({ sortBy, sortDesc }) {
      let campoOrdenado = helpers.primeiraLetraMaiuscula(sortBy)
      let ordem = sortDesc
      this.$emit('alterar-ordenacao', campoOrdenado, ordem);
    },

    abrirModalAtualizarHistoricosEscolares() {
    this.modais.atualizarHistoricos = true;
    this.modais.historicoDadosAluno = {};
    },

    fecharModalAtualizarHistorico() {
    this.modais.atualizarHistoricos = false;
    this.modais.historicoDadosAluno = {};
  }
  },
};
</script>
